
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/product/create",
      function () {
        return require("private-next-pages/product/create.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/product/create"])
      });
    }
  